require('../vendor/lined-textarea/jquery-linedtextarea.coffee')

exports.initialize = (selector) ->
  jQuery(selector).linedtextarea()



// WEBPACK FOOTER //
// ./src/libraries/lined_textarea.coffee